import { SearchIcon } from '@instacart/ids-core'
import { DecoratedInput } from '@retailer-platform/shared-components'
import React, { useMemo, useState, type FunctionComponent } from 'react'

export interface Props {
  onChange: (filter: string) => void
}

export const SearchFilter: FunctionComponent<Props> = ({ onChange }) => (
  <div>
    <DecoratedInput
      id="search"
      decorationComponent={SearchIcon}
      decorationPosition={'left'}
      placeholder={'Search'}
      onChange={evt => {
        onChange(evt.currentTarget.value || '')
      }}
    />
  </div>
)
